import { render, staticRenderFns } from "./ControlTable.vue?vue&type=template&id=657227d8&scoped=true"
import script from "./ControlTable.vue?vue&type=script&lang=js"
export * from "./ControlTable.vue?vue&type=script&lang=js"
import style0 from "./ControlTable.vue?vue&type=style&index=0&id=657227d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657227d8",
  null
  
)

export default component.exports